import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { DataAppContext } from '../DataContext';
import './SecureLeftPanel.css';

const SecureLeftPanel = () => {
 const usertype = localStorage.getItem('usertype')?.toLowerCase().trim();
  const { appstate } = useContext(DataAppContext);
  const location = useLocation();   // 🔹 NEW

  const isOpen =
    appstate.sidebarOpen !== undefined
      ? appstate.sidebarOpen
      : true;

  // 🔹 helper to add active class
  const getLinkClass = (path) => {
  if (path === "/") {
    return `nav-link-custom ${location.pathname === "/" ? 'active' : ''}`;
  }
  return `nav-link-custom ${location.pathname.startsWith(path) ? 'active' : ''}`;
};

  return (
    <div className={`secure-left-panel-placeholder ${isOpen ? 'open' : 'collapsed'}`}>
      <div className={`secure-left-panel ${isOpen ? '' : 'collapsed'}`}>

        {/* ================= ADMIN SECTION ================= */}
        {appstate.loginstatus && usertype === 'admin' && (
          <>
            <div className="panel-header">
              <span className="admin-badge">
                {isOpen ? 'Admin Options' : 'AO'}
              </span>
            </div>

            <ul className="nav-links">

              <li className="nav-item">
                <Link to="/dashboard" className={getLinkClass("/dashboard")}>
                  {isOpen ? 'Admin Dashboard' : 'AD'}
                </Link>
              </li>

              <li className="nav-item">
                <Link to="/imageslist" className={getLinkClass("/imageslist")}>
                  Images List
                </Link>
              </li>

              <li className="nav-item">
                <Link to="/career" className={getLinkClass("/career")}>
                  Career CRUD
                </Link>
              </li>

              <li className="nav-item">
                <Link to="/contact" className={getLinkClass("/contact")}>
                  Contact CRUD
                </Link>
              </li>

              <li className="nav-item">
                <Link to="/blogslist" className={getLinkClass("/blogslist")}>
                  Blogs CRUD
                </Link>
              </li>

              <li className="nav-item">
                <Link to="/categorylist" className={getLinkClass("/categorylist")}>
                  Category CRUD
                </Link>
              </li>

              <li className="nav-item">
                <Link to="/postlist" className={getLinkClass("/postlist")}>
                  Post Content CRUD
                </Link>
              </li>

              <li className="nav-item">
                <Link to="/pagecontentlist" className={getLinkClass("/pagecontentlist")}>
                  Page Content CRUD
                </Link>
              </li>

              <li className="nav-item">
                <Link to="/pages" className={getLinkClass("/pages")}>
                  Pages CRUD
                </Link>
              </li>

              <li className="nav-item">
                <Link to="/portfoliolist" className={getLinkClass("/portfoliolist")}>
                  Portfolio CRUD
                </Link>
              </li>

              <li className="nav-item">
                <Link to="/testimonialslist" className={getLinkClass("/testimonialslist")}>
                  Testimonial CRUD
                </Link>
              </li>

              <li className="nav-item">
  <Link to="/users" className={getLinkClass("/users")}>
    Users CRUD
  </Link>
</li>

              <li className="nav-item">
                <Link to="/placedCandidates" className={getLinkClass("/placedCandidates")}>
                  Placed Candidates
                </Link>
              </li>

              <li className="nav-item">
                <Link to="/" className={getLinkClass("/")}>
                  Back to Home
                </Link>
              </li>

            </ul>
          </>
        )}

        {/* ================= CONTENT ADMIN SECTION ================= */}
        {appstate.loginstatus && usertype === 'contentadmin' && (
          <>
            <div className="panel-header">
              <span className="admin-badge">
                {isOpen ? 'Content Admin' : 'CA'}
              </span>
            </div>

            <ul className="nav-links">
              <li className="nav-item">
                <Link to="/blogslist" className={getLinkClass("/blogslist")}>
                  Blogs
                </Link>
              </li>
            </ul>
          </>
        )}

      </div>
    </div>
  );
};

export default SecureLeftPanel;